import { ca } from '@cian/analytics';
import { IPageViewObject } from '../../types/analytics';

/**
 * Отправка события открытия новой страницы
 * https://conf.cian.tech/pages/viewpage.action?pageId=1311539818
 * @param { IPageViewObject } pageViewObject - Объект для события page view
 */
export const trackNewPage = (pageViewObject: IPageViewObject) => {
  ca('pageviewSite', {
    action: 'newpage',
    category: 'page',
    label: 'open',
    name: 'newpage',
    ...pageViewObject,
  });
};
